<template>
  <v-dialog
    v-model="dialogChapter.show"
    :max-width="dialogChapter.maxWidth"
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ dialogChapter.dialogTitle }}</span>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" icon @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col v-if="dialogChapter.mode === 1" cols="3">
            <v-select
              v-model="dialogChapter.clickedActiveMenu.level"
              :items="levelList"
              label="節點層級"
              @change="changeLeave()"
            ></v-select>
          </v-col>
          <v-col :cols="dialogChapter.mode === 1 ? 9 : 12">
            <v-text-field
              label="中文節點名稱 *"
              required
              autofocus
              :disabled="dialogChapter.mode === 3"
              v-model="dialogChapter.clickedActiveMenu.topic"
            ></v-text-field>
            <v-text-field
              label="英文節點名稱"
              required
              :disabled="dialogChapter.mode === 3"
              v-model="dialogChapter.clickedActiveMenu.topicEn"
            ></v-text-field>
          </v-col>
          <template v-if="dialogChapter.mode === 1">
            <v-col v-if="dialogChapter.clickedActiveMenu.level > 2" cols="6">
              <v-select
                :items="grandparentList()"
                v-model="grandparentId"
                item-text="topic"
                item-value="menuId"
                label="上層節點篩選"
              ></v-select>
            </v-col>
            <v-col v-if="dialogChapter.clickedActiveMenu.level >= 2" cols="6">
              <v-select
                :items="filterFirstMenu()"
                v-model="dialogChapter.clickedActiveMenu.parentId"
                item-text="topic"
                item-value="menuId"
                label="上層節點"
              ></v-select>
            </v-col>
          </template>
          <v-col
            v-if="[1, 3].includes(dialogChapter.mode)"
            :cols="dialogChapter.clickedActiveMenu.level >= 2 ? 6 : 12"
          >
            <v-select
              :items="filterSubMenu()"
              v-model="followSn"
              item-text="topic"
              item-value="sn"
              label="在哪個節點之後"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="dialogChapter.mode === 2"
          color="blue darken-1"
          text
          @click.stop="turn(dialogChapter.clickedActiveMenu)"
        >
          {{ dialogChapter.clickedActiveMenu.flag === 1 ? '停用' : '啟用' }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="save()"> 儲存 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  name: 'DialogChapter',

  props: ['activeMenuList', 'editedAuth'],

  data() {
    return {
      grandparentId: 0,
      followSn: 0
    }
  },

  computed: {
    ...mapState('document', [
      'dialogChapter',
      'levelList',
      'allChapterList',
      'showRemoveData'
    ]),
    ...mapGetters('document', {
      mapActiveMenuListByLv: 'getActiveMenuListByLv'
    }),
    clickedActiveMenuIndex() {
      return this.activeMenuList
        .map(function (x) {
          return x.menuId
        })
        .indexOf(this.dialogChapter.clickedActiveMenu.menuId)
    }
  },

  watch: {
    'dialogChapter.show': function (newVal) {
      if (newVal) {
        const sn = parseInt(this.dialogChapter.clickedActiveMenu.sn)
        if (this.dialogChapter.mode === 1) {
          this.followSn =
            this.dialogChapter.clickedActiveMenu.level === 1 ? 1 : 0
        } else if (this.dialogChapter.mode === 3) {
          this.followSn = sn === 1 ? sn : sn - 1
        }
      }
    }
  },

  methods: {
    ...mapActions('document', ['setDialogChapter']),
    ...mapActions('message', ['setSnackbar']),
    closeDialog() {
      this.grandparentId = 0
      this.setDialogChapter()
    },
    changeLeave() {
      const level = this.dialogChapter.clickedActiveMenu.level
      this.followSn = level === 1 ? 1 : 0
    },
    grandparentList() {
      let arr = [{ menuId: 0, topic: '全部' }]
      const level = this.dialogChapter.clickedActiveMenu.level
      for (const i in this.mapActiveMenuListByLv) {
        const lv = parseInt(i.split('_')[0])
        if (lv === level - 2) {
          arr = arr.concat(
            this.mapActiveMenuListByLv[i].sort(function (a, b) {
              return a.sn > b.sn ? 1 : -1
            })
          )
        }
      }
      return arr
    },
    filterFirstMenu() {
      const level = this.dialogChapter.clickedActiveMenu.level
      let arr = []
      for (const i in this.mapActiveMenuListByLv) {
        const lv = parseInt(i.split('_')[0])
        let curr = this.mapActiveMenuListByLv[i].sort(function (a, b) {
          return a.sn > b.sn ? 1 : -1
        })
        if (lv === level - 1) {
          if (this.grandparentId !== 0) {
            curr = curr.filter((item) => {
              return item.parentId === this.grandparentId
            })
          }
          arr = arr.concat(curr)
        }
      }

      return arr
    },
    filterSubMenu() {
      const curr = this.dialogChapter.clickedActiveMenu
      const level = curr.level
      const data = JSON.parse(JSON.stringify(this.mapActiveMenuListByLv))

      let arr = []
      if (level > 1) {
        arr.push({ topic: '無', sn: 0 })
      }

      const key = level + '_' + curr.parentId
      if (data[key]) {
        arr = arr.concat(
          data[key]
            .sort(function (a, b) {
              return a.sn > b.sn ? 1 : -1
            })
            .filter((item) => {
              return item.menuId !== curr.menuId
            })
        )
      }
      return arr
    },
    save() {
      const data = JSON.parse(
        JSON.stringify(this.dialogChapter.clickedActiveMenu)
      )

      // 編輯權限
      if (!this.editedAuth) {
        this.setSnackbar({ show: true, text: '權限不足。', type: 'text' })
        return
      }

      // 節點中文是否填寫
      if (!data.topic) {
        this.setSnackbar({ show: true, text: '請填節點名稱。', type: 'text' })
        return
      }

      switch (this.dialogChapter.mode) {
        case 1: {
          // create
          data.sn = this.followSn + 1
          switch (data.level) {
            case 1:
              data.parentId = 0
              if (data.sn === 1) {
                // 第一層第一筆必須是版本紀錄，故自動調整成第二
                data.sn = 2
              }
              break
            default:
              if (data.parentId === 0) {
                this.setSnackbar({
                  show: true,
                  text: '請選擇上層選單。',
                  type: 'text'
                })
                return
              }
          }
          this.$api.common.node.create(data).then((res) => {
            this.grandparentId = 0
            this.followSn = 0
            this.$emit('mapResult')
          })
          break
        }
        case 2: {
          // edit
          const dataEdit = {
            menuId: data.menuId,
            topic: data.topic,
            topicEn: data.topicEn
          }

          this.$api.common.node.setTopic(dataEdit).then((res) => {
            this.grandparentId = 0
            this.$emit('mapResult')
          })
          break
        }
        case 3: {
          // sort
          data.sn = this.followSn + 1
          const dataEdit = {
            menuId: data.menuId,
            sn:
              data.menuId !== 1 && data.level === 1 && data.sn === 1
                ? data.sn + 1
                : data.sn
          }
          this.$api.common.node.swap(dataEdit).then((res) => {
            this.grandparentId = 0
            this.followSn = 0
            this.$emit('mapResult')
          })
          break
        }
      }
    },
    turn(item) {
      const data = {
        menuId: item.menuId,
        flag: item.flag === 1 ? 0 : 1
      }
      this.$api.common.node.turn(data).then((res) => {
        this.grandparentId = 0
        this.$emit('mapResult')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
